export const enum PusherChannels {

    COMPANY_PUBLIC = '.company.{UUID}.public',
    COMPANY_PRIVATE = '.company.{UUID}.private',
    THREAD_PRIVATE = '.thread.{UUID}',
}
